export const SEND_TICKET = 'SEND_TICKET';
export const SEND_TICKET_DONE = 'SEND_TICKET_DONE';
export const SEND_TICKET_ERROR = 'SEND_TICKET_ERROR';
export const RESET_SEND_TICKET = 'RESET_SEND_TICKET';
//# sourceMappingURL=actionTypes.js.map